import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const WrapperStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 1rem;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  margin-bottom: 6rem;
  height: 5.8rem;
  padding: 1.6rem;
`;

export const FileNameSectionStyled = styled.div`
  display: flex;
  align-items: center;
`;

export const FileButtonStyled = styled(Button)`
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 2.4rem;
`;

export const PageFooterStyled = styled.footer`
  display: flex;
  justify-content: center;
`;
